const ContainsQueryMixin = (superClass) => class extends superClass {
  query = null;

  setQuery(query) {
    this.query = query;
  }
};

export default ContainsQueryMixin;
